import { render } from "./dashboard.vue?vue&type=template&id=0a9f9ed8&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=0a9f9ed8&lang=scss&scoped=true"

import exportComponent from "/Users/alessiopracchia/Projects/innexta/bilanci/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9f9ed8"]])

export default __exports__